import { render, staticRenderFns } from "./NumberMetricForm.vue?vue&type=template&id=8ebf215c&scoped=true"
import script from "./NumberMetricForm.vue?vue&type=script&lang=js"
export * from "./NumberMetricForm.vue?vue&type=script&lang=js"
import style0 from "./NumberMetricForm.vue?vue&type=style&index=0&id=8ebf215c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebf215c",
  null
  
)

export default component.exports